export function openInIFrame(location, target) {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);
  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

  const script = iframeDoc.createElement('script');
  script.type = 'text/javascript';
  script.text = `
    const newWindow = window.open("", "${target}");
    newWindow.opener = null;
    newWindow.location = "${location}";
  `;
  iframeDoc.body.appendChild(script);
  document.body.removeChild(iframe);
}
